<!--<app-loader></app-loader>-->
<app-tap-to-top></app-tap-to-top>
<router-outlet></router-outlet>
<app-kb-chatbot *ngIf="enableKbChatbot"></app-kb-chatbot>
